// Hook
// Parameter is the boolean, with default "false" value

export const useCurrentLng = (): string | null => {
  return localStorage.getItem('i18nextLng');
};
